/** @format */
import { rgba } from 'emotion-rgba';
import { css } from 'styled-components';

import { StyledStickyFooterProps } from './index';

/**
 * Base styles for the sticky footer component
 *
 * @param {StyledStickyFooterProps} props The sticky footer properties object
 * */
/* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
const baseStyles = ({ height }: StyledStickyFooterProps) => css`
    .sticky-footer-wrapper {
        z-index: 0;
        pointer-events: none;
        bottom: 0;
        left: 0;
        right: 0;
    }

    .sticky-footer-container {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        pointer-events: auto;
        background: var(--colors-surface-primary);
        z-index: var(--z-index-sticky-footer);
        box-shadow: 0 -0.3rem 1rem ${rgba('#0b002b', 0.1)};
    }

    .sticky-footer-gradient {
        position: fixed;
        bottom: ${height}px;
        left: 0;
        right: 0;
        height: ${height}px;
        z-index: 9;
        background: linear-gradient(
            to bottom,
            rgba(255, 255, 255, 0) 75%,
            rgba(255, 255, 255, 0.2) 100%
        );
    }

    .sticky-footer-shim {
        height: ${height}px;
    }
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */

/**
 * The sticky footer component styles
 *
 * @param {StyledStickyFooterProps} props The sticky footer properties object
 * */
export const styles = (props: StyledStickyFooterProps) => css`
    ${baseStyles(props)}
`;
